import router from './router'
import store from './store'
import { Message, MessageBox } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken } from '@/utils/auth' // getToken from cookie
import Config from '@/config'
import { filterAsyncRouter } from './store/modules/permission'
import { removeToken } from '@/utils/auth' // getToken from cookie

NProgress.configure({ showSpinner: false })// NProgress Configuration

const whiteList = ['/index', '/infoTenant', '/party', '/partyM', '/demonstration', '/partyLC', '/partyZY', '/partyLCAH', '/partyHN', '/BS', '/threeParty' ]// no redirect whitelist

// auth judge function
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('ADMIN') >= 0) return true // admin auth passed directly
  if (!permissionRoles) return true
  return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

router.beforeEach((to, from, next) => {
  // console.log(to.meta.title)
  // console.log(Config.webName)
  // if (to.meta.title) {
  //   document.title = to.meta.title + ' - ' + Config.webName
  // }
  NProgress.start() // start progress bar
    if (getToken()) { // determine if there has token
      /* has token*/
      if (to.path === '/index') {
        next({ path: '/' })
        NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
      } else {
        if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
          store.dispatch('GetInfo').then(res => { // 拉取user_info
            let tenantId = res.tenant.id
            if (res.tenant === 0) {
                if(localStorage.getItem('language') == 'en'){
                  if(res.indexflag == 99){
                    next({ ...to , replace: true })// hack方法 确保addRoutes已完成
                  }else{
                    next({ path: '/myEx' })
                  }
                }else if(localStorage.getItem('language') == 'zh'){
                  if(res.indexflag == 99){
                    next({ ...to , replace: true })// hack方法 确保addRoutes已完成
                  }else{
                    next({ path: '/myEx' })
                  }
                }else{
                  localStorage.setItem('language','zh');
                  if(res.indexflag == 99){
                    next({ ...to , replace: true })// hack方法 确保addRoutes已完成
                  }else{
                    next({ path: '/myEx' })
                  }
                }
            } else {
                if(tenantId == 12 || tenantId == 30 || tenantId == 29){
                  localStorage.setItem('language','zh');
                  next({ path: '/demo' })// hack方法 确保addRoutes已完成 ——2020/02/18因刷新重定向到首页更改
                }else if(tenantId == 31 || tenantId == 38){
                  localStorage.setItem('language','zh');
                  next({ path: '/expand' })// hack方法 确保addRoutes已完成 ——2020/02/18因刷新重定向到首页更改
                }else{
                  localStorage.setItem("newKey", to.query.key);
                  localStorage.setItem("newUserToken", to.query.accessToken);
                  localStorage.setItem('language','zh');
                  if(res.resource == null){
                    next({ path: '/tenant' })// hack方法 确保addRoutes已完成 ——2020/02/18因刷新重定向到首页更改
                  }else{
                    if(res.resource.infoIsFree == null){
                      res.resource.infoIsFree = ''
                    }
                    if(res.resource.infoNodeName == null){
                      res.resource.infoNodeName = ''
                    }
                    if(res.resource.infoSearch == null){
                      res.resource.infoSearch = ''
                    }
                    if(res.resource.infoTreeId == null){
                      res.resource.infoTreeId = ''
                    }
                    if(res.resource.infoisStudy == null){
                      res.resource.infoisStudy = ''
                    }
                    if(res.resource.infoMb == null){
                      res.resource.infoMb = ''
                    }
                    if(sessionStorage.getItem('userBackIndex') == 1){
                      next({ path: '/tenant' })// hack方法 确保addRoutes已完成 ——2020/02/18因刷新重定向到首页更改
                    }else{
                      if(res.resource.infoStudy == 0){
                        next({ path: '/Cinfo?infoId='+res.resource.infoId+'&infoBrowseNum='+res.resource.infoBrowseNum+'&infoNumber='+res.resource.infoNumber+'&infoTreeId='+res.resource.infoTreeId+'&infoNodeName='+res.resource.infoNodeName+'&infoIsFree='+res.resource.infoIsFree+'&infoSearch='+res.resource.infoSearch+'&infoStudy='+res.resource.infoStudy })// hack方法 确保addRoutes已完成 ——2020/02/18因刷新重定向到首页更改
                      }else{
                        next({ path: '/CinfoTj?infoId='+res.resource.infoId+'&infoBrowseNum='+res.resource.infoBrowseNum+'&infoMb'+res.resource.infoMb+'&infoNumber='+res.resource.infoNumber+'&infoTreeId='+res.resource.infoTreeId+'&infoNodeName='+res.resource.infoNodeName+'&infoIsFree='+res.resource.infoIsFree+'&infoSearch='+res.resource.infoSearch+'&infoStudy='+res.resource.infoStudy })// hack方法 确保addRoutes已完成 ——2020/02/18因刷新重定向到首页更改
                      }
                    }
                  }
                }
            }
          }).catch((err) => {
            store.dispatch('LogOut').then(() => {
              Message.error(err || '验证失败，请重新登陆')
              next({ path: '/index' })
            })
          })
        } else {
          // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
          if (hasPermission(store.getters.roles, to.meta.roles)) {
            next()
          } else {
            next({ path: '/401', replace: true, query: { noGoBack: true }})
          }
        }
      }
    } else {
      /* has no token*/
      if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
        next()
      } else {
        // MessageBox.confirm(
        //   '请您先登录，或拨打电话咨询:（025）83557366',
        //   '提示',
        //   {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }
        // )
        next(`/index`) // 否则全部重定向到登录页
        NProgress.done()
      }
    }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})


// WEBPACK FOOTER //
// ./src/permission.js